module.exports = __webpack_public_path__ + "3226c145871a1e7b256d05e227fc9099.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/standards.png
// module id = 1109
// module chunks = 0